
















import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import ContentsPage from "@/components/ContentsPage.vue";

import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    ContentsPage,
    Footer,
  },
})
export default class Poster extends Vue {
  protected contentsPoster= [
    {
    ContentsTitle:  "LES FONDAMENTAUX DE L'AFFICHE",
    ContentsPath: "/Affiche/Fondamentaux",
    ContentsImage: "/thumbnail3.png"
    },
    {
    ContentsTitle: "CONSEILS ET ASTUCES",
    ContentsPath: "/Affiche/Astuces",
    ContentsImage:"/thumbnail4.png"
    },
    {
    ContentsTitle: "EN PRATIQUE...",
    ContentsPath: "/Affiche/EnPratique",
    ContentsImage:"/thumbnail1.png"
    },
       {
    ContentsTitle: "POUR TROUVER L'INSPIRATION...",
    ContentsPath: "/Affiche/Trouver_lInspiration",
    ContentsImage:"/thumbnail7.png"
    },
  ]

}
